import { component } from 'picoapp'
import { zelektor, loopify, smoothScroll } from '@/lib/utility-functions.js'

export default component((node,ctx) => {
    /*******************************************************************************************************************************************/
    /* Data + Elements
    /*******************************************************************************************************************************************/
    const { nav, content } = zelektor(node)
    const headings = content.querySelectorAll('h2')


    /*******************************************************************************************************************************************/
    /* Create Nav
    /*******************************************************************************************************************************************/
    createNav()
    initNav()
    
    function createNav() {
        headings.forEach((heading, index) => {
            const btn = document.createElement('button')
            btn.setAttribute('type', 'button')
            btn.classList.add('page__nav__item', 'js-navBtn')
            btn.innerText = heading.innerText
            nav.appendChild(btn)
            
            btn.dataset.index = index
            heading.dataset.index = index
        })
    }

    function initNav() {
        const { navBtn: navBtns = [] } = zelektor(nav)

        loopify(navBtns).forEach(btn => {
            btn.addEventListener('click', clickNavBtn)
        })
    }

    function clickNavBtn(e) {
        const thisBtn = e.currentTarget
        const { index } = thisBtn.dataset
        const heading = [...headings].find(h => h.dataset.index === index)
        
        scrollToHeading(heading)
    }

    function scrollToHeading(heading) {
        let offset = -(window.theme.headerMainHeight + 20)
        // if (window.innerWidth <= 1024) offset -= nav.offsetHeight

        smoothScroll(heading, { offset })
    }
})